
import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { CategoryBadge } from "./CategoryBadge";

interface BlogCardProps {
  title: string;
  excerpt: string;
  date: string;
  image: string;
  slug: string;
  category: string;
}

export const BlogCard = ({
  title,
  excerpt,
  date,
  image,
  slug,
  category,
}: BlogCardProps) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    const target = e.target as HTMLImageElement;
    target.src = "/placeholder.svg";
  };

  return (
    <Link to={`/blog/${slug}`} className="group">
      <div className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
        <div className="aspect-w-16 aspect-h-9 relative">
          <img
            src={image || "/placeholder.svg"}
            alt={title}
            className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
            onError={handleImageError}
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <CategoryBadge category={category} />
          </div>
        </div>
        <div className="p-5">
          <div className="flex items-center text-dental-muted text-sm mb-2">
            <Calendar size={16} className="mr-1" />
            <span>{date}</span>
          </div>
          <h3 className="text-lg font-serif font-medium text-dental-text mb-2 group-hover:text-dental-highlight transition-colors line-clamp-2">{title}</h3>
          <p className="text-dental-muted text-sm mb-4 line-clamp-3">{excerpt}</p>
          <span className="text-dental-highlight font-medium text-sm inline-flex items-center">
            Read More
            <svg className="w-4 h-4 ml-1 group-hover:ml-2 transition-all" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </span>
        </div>
      </div>
    </Link>
  );
};
